// extracted by mini-css-extract-plugin
export default {"classTitle":"ClassTitle_classTitle__Dcl4x","className":"ClassTitle_className__HcSo2"};